import { studio } from "@/data/site";

export const Marquee = ({ items = studio.marquee }) => {
  const row = [...items, ...items, ...items, ...items];
  return (
    <div
      data-testid="studio-marquee"
      className="relative overflow-hidden border-y py-5 sm:py-7"
      style={{ borderColor: "var(--line)", background: "var(--ink-2)" }}
    >
      <div className="marquee-track flex w-max items-center gap-10 sm:gap-16">
        {row.map((item, i) => (
          <span key={i} className="flex items-center gap-10 sm:gap-16">
            <span className="font-display whitespace-nowrap text-lg font-bold uppercase tracking-tight text-white/45 sm:text-2xl">
              {item}
            </span>
            <span
              aria-hidden
              className="h-1.5 w-1.5 shrink-0 rounded-full"
              style={{ background: "var(--accent)" }}
            />
          </span>
        ))}
      </div>
      <div
        className="pointer-events-none absolute inset-y-0 left-0 w-16 sm:w-32"
        style={{ background: "linear-gradient(90deg, var(--ink-2), transparent)" }}
      />
      <div
        className="pointer-events-none absolute inset-y-0 right-0 w-16 sm:w-32"
        style={{ background: "linear-gradient(270deg, var(--ink-2), transparent)" }}
      />
    </div>
  );
};
